import styled from "styled-components/native";
import ImgProgressBar from "./ImgProgressBar";
import TabsViewNarrowLoader from "./TabsViewNarrowLoader";

const StyledMain = styled.View`
	flex-direction: row;
	background: black;
	gap: 1.5rem;
`;
const StyledNarrowFrame = styled.View`
	display: flex;
	width: 57.5rem;
	flex-direction: row;
	gap: 1.5rem;
	top: 2rem;
`;

const StyledButtonContainerNarrow = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	flex-shrink: 0;
`;

const StyledButtonLoader = styled.View`
	height: 3.5rem;
	width: 100%;
	border-radius: 16px;
	overflow: hidden;
`;

const StyledTextTemplateNarrow = styled.View<any>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
	width: 31.25rem;
`;

const StyledTextFrame = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;
const StyledTabsContainer = styled.View`
	display: flex;
	width: 18.75rem;
	align-items: flex-start;
	align-self: stretch;
`;

const StyledSynopsisContainer = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
	align-self: stretch;
`;
const StyledSynopsis = styled.View`
	height: 1rem;
	align-self: stretch;
	border-radius: 1rem;
`;
const StyledGenreContainer = styled.View`
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
	align-self: stretch;
	flex-direction: row;
`;

const StyledGenre = styled.View<any>`
	display: flex;
	align-items: flex-start;
	gap: 0.625rem;
	border-radius: 0.25rem;
	width: 3rem;
	height: 1rem;
`;

const renderButtonLoaderNarrow = () => {
	return (
		// @ts-ignore
		<StyledButtonContainerNarrow>
			{/* @ts-ignore */}
			<StyledButtonLoader>
				<ImgProgressBar />
			</StyledButtonLoader>

			{/* @ts-ignore */}
			<StyledButtonLoader>
				<ImgProgressBar />
			</StyledButtonLoader>

			{/* @ts-ignore */}
			<StyledButtonLoader>
				<ImgProgressBar />
			</StyledButtonLoader>
		</StyledButtonContainerNarrow>
	);
};

const renderTextTemplateNarrow = () => {
	return (
		//@ts-ignore
		<StyledTextTemplateNarrow>
			{/* @ts-ignore */}
			<StyledTextFrame>
				{/* @ts-ignore */}
				<StyledGenreContainer>
					<StyledGenre>
						<ImgProgressBar isNoBorder />
					</StyledGenre>
					<StyledGenre>
						<ImgProgressBar isNoBorder />
					</StyledGenre>
					<StyledGenre>
						<ImgProgressBar isNoBorder />
					</StyledGenre>
				</StyledGenreContainer>
				{/* @ts-ignore */}
				<StyledSynopsisContainer>
					{/* @ts-ignore */}
					<StyledSynopsis>
						<ImgProgressBar />
					</StyledSynopsis>
					{/* @ts-ignore */}
					<StyledSynopsis>
						<ImgProgressBar />
					</StyledSynopsis>
				</StyledSynopsisContainer>
				{/* @ts-ignore */}
				<StyledSynopsisContainer>
					{/* @ts-ignore */}
					<StyledSynopsis>
						<ImgProgressBar />
					</StyledSynopsis>
					{/* @ts-ignore */}
					<StyledSynopsis>
						<ImgProgressBar />
					</StyledSynopsis>
					{/* @ts-ignore */}
					<StyledSynopsis>
						<ImgProgressBar />
					</StyledSynopsis>
				</StyledSynopsisContainer>
			</StyledTextFrame>
		</StyledTextTemplateNarrow>
	);
};

const TitleDetailsNarrowLoader = () => {
	return (
		<>
			{/* @ts-ignore */}
			<StyledMain>
				{/* @ts-ignore */}
				<StyledTabsContainer>
					<TabsViewNarrowLoader />
				</StyledTabsContainer>

				{/* @ts-ignore */}
				<StyledNarrowFrame>
					{renderButtonLoaderNarrow()}
					{renderTextTemplateNarrow()}
				</StyledNarrowFrame>
			</StyledMain>
		</>
	);
};

export default TitleDetailsNarrowLoader;
